// Lot 730 — variantes d'un emoji de la barre de réactions (appui long, façon WhatsApp) : teintes de peau pour les mains,
// familles proches pour les visages / cœurs. Le 1er élément est toujours l'emoji de base.
// Lot 731 — la dernière teinte de peau choisie est mémorisée : 🙏 et 👍 de la barre rapide l'utilisent directement.
export const SKIN_TONES = ["🏻", "🏼", "🏽", "🏾", "🏿"];
const SKIN = ["", ...SKIN_TONES];
const skin = (base) => SKIN.map((s) => base + s);
const SKIN_BASES = ["🙏", "👍"];

export const EMOJI_VARIANTS = {
  "🙏": skin("🙏"),
  "👍": skin("👍"),
  "❤️": ["❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍", "💖", "💔"],
  "😂": ["😂", "🤣", "😅", "😆", "😁", "😹"],
  "😮": ["😮", "😲", "😯", "🤯", "😱", "🫢"],
  "😢": ["😢", "😭", "🥺", "😔", "😞", "😿"],
};

export const variantsOf = (emoji) => EMOJI_VARIANTS[emoji] || [emoji];
export const hasVariants = (emoji) => variantsOf(emoji).length > 1;
export const LONG_PRESS_MS = 420;

export const skinToneOf = (emoji) => SKIN_TONES.find((t) => (emoji || "").endsWith(t)) || "";
export const baseOf = (emoji) => { const t = skinToneOf(emoji); return t ? emoji.slice(0, -t.length) : emoji; };
export const hasSkinTones = (emoji) => SKIN_BASES.includes(baseOf(emoji));
export const withSkinTone = (emoji, tone) => (hasSkinTones(emoji) && tone ? baseOf(emoji) + tone : emoji);

const TONE_KEY = "yalola.skinTone";
export const readSkinTone = () => { try { const v = localStorage.getItem(TONE_KEY) || ""; return SKIN_TONES.includes(v) ? v : ""; } catch { return ""; } };
export const writeSkinTone = (tone) => { try { if (tone) localStorage.setItem(TONE_KEY, tone); else localStorage.removeItem(TONE_KEY); } catch { /* noop */ } };
